const flags = {
  "arrivalActions": [],
  "feastActions": [],
  "time": 0,
  "inventory": {
    "alcohol": {
      "name": `Calabash of hard liquor`,
    },
    "dolphin": {
      "name": `Pendant`,
    },
    "pearls": {
      "name": `Handful of black pearls`,
    },
    "smokePearls": {
      "name": `Handful of smoke pearls`,
    },
    "fruit": {
      "name": `Handful of red fruits`,
    },
    "doll": {
      "name": `Wooden figurine`,
    },
    "net": {
      "name": `Witch’s net`,
    },
    "fieryCalabash": {
      "name": `Calabash of doctored alcohol`,
    },
  },
  "drunk": false,
  "currentIsland": "island-1",
  "visitedIslands": [],
  "eatenByFaanarua": false,
  "talkedWithFaanarua": false,
  "triedToFlee": false,
  "drunkAtTheWitchCup": false,
  "caughtInAWitchNet": false,
  "touchedACursedItem": false,
  "damagedBoat": false,
  "eatenByCrocodile": false,
  "swumUnderWitchIsland": false,
  "wellRested": false,
  "boostedByFruit": false,
  "eatenByRaiahui": false,
  "stabbedToDeath": false,
  "survivedTheTrial": false,
  "toldAboutFaanaruaByRaiahui": false,
  "toldAboutAtollByRaiahui": false,
  "toldAboutLazyOneByAriinea": false,
  "toldAboutFaanaruaByVarenui": false,
  "toldAboutWitchByMonkey": false,
  "watchedKnifeImportance": false,
  "survivedWitchIsland": false,
  "refreshed": false,
  "aVillagerOnCrocodileIsland": false,
  "caughtARaiahui": false,
  "seenRaiahuiTrueForm": false,
  "tastedFruit": false,
  "talkedToPerfectlyUselessDrunkGirl": false,
  "examinedTrialCalabashes": false,
  "playedTheFool": false,
  "flagsBeforeActualTrial": undefined,
  "bleeding": false,
  "weakened": false,
  "gotAHeadStart": false,
  "course": [],
  "targetIsland": undefined,
  "searchedIsland2": false,
  "approachedFaanarua": false,
  "approchedCrocodile": false,
  "encounteredCrocodileAtSea": false,
  "hesitationCounter": 0,
  "wentBeyondIntroduction": false,
  "reachedTheTrial": false,
  "friendlyWithWitch": false,
};

export default flags;



// WEBPACK FOOTER //
// ./src/scripts/flags.js